<template>
  <el-popover
    placement="bottom"
    trigger="focus">
    <div id="ousMainDiv">
      <div class="ousTable">
        <el-table
          :data="tableData"
          border
          stripe
          size="mini"
          :header-cell-style="{background:'#ECF5FF',color:'#606266'}"
          @cell-click="cellClick"
          style="width: 100%"
          height="100%">
          <el-table-column
            type="index"
            label=" "
            width="35">
          </el-table-column>
          <el-table-column
            prop="name"
            align="left"
            header-align="center"
            width="120"
            label="姓名">
          </el-table-column>
          <el-table-column
            prop="phone"
            align="left"
            header-align="center"
            width="120"
            label="联系电话">
          </el-table-column>
          <el-table-column
            prop="eMail"
            align="left"
            header-align="center"
            label="邮箱">
          </el-table-column>
          <el-table-column
            prop="qq"
            aalign="left"
            header-align="center"
            label="QQ号">
          </el-table-column>
        </el-table>
      </div>
      <div class="ousPagination">
        <el-pagination
          small
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="rows"
          layout="total, prev, pager, next, jumper"
          :total="totle">
        </el-pagination>
      </div>
    </div>
    <el-input v-model="inerValue" :placeholder="placeholder" slot="reference"/>
  </el-popover>
</template>

<script>
  import {getUserList} from '../api/baseUser'
  export default {
    name: "el-org-user-select",
    props: {
      /* 初始值 */
      orgId: {
        type: String,
        default: () => {
          return ''
        }
      },
      /* 初始值 */
      value: {
        type: String,
        default: () => {
          return ''
        }
      },
      /* 初始值 */
      placeholder: {
        type: String,
        default: () => {
          return '请选择'
        }
      }
    },
    data () {
      return {
        totle: 0,
        rows: 5,
        inerValue: '',
        currentPage: 1,
        tableData: []
      }
    },
    methods: {
      handleCurrentChange (val) {
        this.currentPage = val
        this.getTableData()
      },
      getTableData: function (orgId) {
        var params = {
          name: this.inerValue,
          orgId: this.orgId === '-1' ? '' : this.orgId,
          page: this.currentPage,
          rows: this.rows
        }
        getUserList(this.$qs.stringify(params)).then(
          response => {
            this.totle = response.total
            if (response.rows != null && response.rows.length > 0) {
              this.tableData = response.rows
            } else {
              this.tableData = []
            }
          })
          .catch(error => {
            console.log('error:' + error.toString())
          })
      },
      cellClick(row, column, cell, event) {
        // this.inerValue = row.name
        this.$emit('getAdmin', {userId:row.userId, userName:row.name})
      }
    },
    mounted() {
      this.getTableData()
    },
    watch: {
      orgId:{
        deep:true,
        immediate:true,
        handler(val){
          this.getTableData();
        }

      },
      // orgId () {
      //   this.currentPage = 1
      //   this.getTableData(this.orgId)
      // },
      value : {
        immediate: true,
        handler: function (newValue) {
          this.inerValue = newValue;
        }
      },
      inerValue() {
        this.getTableData();
      }
    }
  }
</script>

<style>
  #ousMainDiv {
    height: 240px;
  }
  .ousTable {
    height: 217px;
    background: #D9C666;
    line-height: 0px;
  }
  .ousPagination {
    height: 27px;
    margin: 0px 0 -27px;
    background: #ECF5FF;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/OrgUserSelect.vue